<script>

    import { createEventDispatcher } from 'svelte'
    import { FixedpriceStore } from '../stores'

    import NumeralMethods from '../$methods/numeral.methods'
    import DateMethods from '../$methods/date.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'

    const dispatch = createEventDispatcher()

</script>

{#if $FixedpriceStore}
    <div class="columns">
        <div class="column">
            <Value label="Tipo" value={ EnumMethods.get($FixedpriceStore.type) } />
        </div>
        <div class="column">
            <Value label="Estatus" value={ DateMethods.isAfter($FixedpriceStore.expired)? 'Habilitado' : 'Deshabilitado' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Proveedor" value={ $FixedpriceStore.provider } />
        </div>
        <div class="column">
            <Value label="Servicio" value={ $FixedpriceStore.service } />
        </div>
    </div>
    {#if $FixedpriceStore.type === 'national'}
        <div class="columns">
            <div class="column">
                <Value label="Volumétrico mínimo" value={ $FixedpriceStore.volumetricMin } postfix="KG" />
            </div>
            <div class="column">
                <Value label="Volumétrico máximo" value={ $FixedpriceStore.volumetricMax } postfix="KG" />
            </div>
        </div>
    {/if}
    {#if $FixedpriceStore.type === 'local'}
        <div class="columns">
            <div class="column">
                <Value label="Distancia mínima" value={ $FixedpriceStore.kilometresMin } postfix="KM" />
            </div>
            <div class="column">
                <Value label="Distancia máxima" value={ $FixedpriceStore.kilometresMax } postfix="KM" />
            </div>
        </div>
    {/if}
    <div class="columns">
        <div class="column">
            <Value label="Precio envío" value={ NumeralMethods.cash($FixedpriceStore.shipmentPrice) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha expiración" value={ DateMethods.dateTimeLarge($FixedpriceStore.expired) } />
        </div>
    </div>
{/if}